module.exports = __webpack_public_path__ + "img/courses_empty04.6f0d863.png";